import type {Theme, ThemeFontWeight, WithThemeProp} from '../theme';

import {getInByToken} from '../../utils/object';

/**
 * Utility to get font weight from the theme by token
 * inside the css`` or styled`` template literal.
 *
 * @param fontWeight
 *
 * @example
 * css`
 *  font-weight: ${getFontWeight('semibold')};
 * `
 */
export const getFontWeight =
  (fontWeight?: ThemeFontWeight) =>
  <ComponentProps extends WithThemeProp>(p: ComponentProps) =>
    fontWeight
      ? getInByToken<Theme['fontWeight']>(p.theme.fontWeight, fontWeight)
      : fontWeight;
